import React, { FC, useCallback } from 'react'
import { Box, Typography } from '@mui/material'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import { FormsFormValues } from './formsForm.constants'
import FormsFormFields from './FormsFormFields'
import { useFormsFormHandlers } from './useFormsFormHandlers'

interface FormsFormProps {
  values: FormsFormValues
  editingId: string | null
  isSubmitting: boolean
  setFieldValue: (field: keyof FormsFormValues, value: any) => void
  onSubmit: (e?: React.FormEvent) => Promise<void>
  onReset: () => void
  onSnackbar: (message: string, severity: 'success' | 'error' | 'warning') => void
}

const FormsForm: FC<FormsFormProps> = ({
  values,
  editingId,
  isSubmitting,
  setFieldValue,
  onSubmit,
  onReset,
  onSnackbar,
}) => {
  const handlers = useFormsFormHandlers({ setFieldValue, values, onSnackbar })

  const handleFormSubmit = useCallback(
    async (e?: React.FormEvent) => {
      e?.preventDefault()
      await onSubmit(e)
    },
    [onSubmit]
  )

  return (
    <Box
      sx={{
        mt: 4,
        border: '1px solid #e5e7eb',
        borderRadius: 7,
        p: { xs: 3, md: 9 },
        px: { lg: 15, md: 5, xs: 7 },
        m: 3,
        backgroundColor: '#fff',
      }}
      component="form"
      onSubmit={handleFormSubmit}
    >
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          mb: 5,
          width: '100%',
          pl: { sx: 2, md: '9rem' },
        }}
      >
        <FormatListBulletedIcon />
        <Typography variant="h5" fontWeight={500}>
          {editingId ? 'Editar Formato' : 'Agregar Formatos'}
        </Typography>
      </Box>

      <FormsFormFields
        name={values.name}
        type={values.type}
        document={values.document}
        editingId={editingId}
        isSubmitting={isSubmitting}
        onNameChange={handlers.handleNameChange}
        onTypeChange={handlers.handleTypeChange}
        onDocumentSelect={handlers.handleDocumentSelect}
        onRemoveDocument={handlers.handleRemoveDocument}
        onReset={onReset}
      />
    </Box>
  )
}

export default FormsForm
